import {useState, useEffect} from 'react'

export const useCustomersFilter = (data,filterQuery) => {
    const [result, setResult] = useState([])

    const checkCustomer = (query) => (customer) => {
        const searchableValues = [
            customer.address,
            customer.city,
            customer.contact_name,
            customer.customer_number,
            customer.email,
            customer.name,
            customer.phone,
        ];
        const normalizedQuery = query.trim().toLocaleLowerCase();

        if (searchableValues.some((value) =>
            value != null && String(value).toLocaleLowerCase().includes(normalizedQuery)
        )) return customer
    }
    
    useEffect(()=>{
        const filterData = () => {
            if(filterQuery){
                const filteredData = data?.filter?.(checkCustomer(filterQuery)) || []
                setResult(filteredData)
                return
            }
            setResult(data || [])
        }
        filterData()
        
    },[data, filterQuery])

    return result
}